"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3707],{

/***/ 3707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MapBox; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../wif-ui-lib/dist/index-66bc4f34.mjs
var index_66bc4f34 = __webpack_require__(8572);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/MapBox/MapBox.tsx









var MAPBOX_TILE_LAYER = "cla10awls00fh15smgiuj4w69" || 0;
var MAPBOX_TOKEN = "pk.eyJ1IjoidmlzaXRmaW5sYW5kIiwiYSI6ImNsOTZzNmpiZDAxaTAzbnE4MTF2MzN0MmIifQ.HCueZTGnp4U9HjYpHO7IUA" || 0;
function MapBox(param) {
    var multi = param.multi;
    var isPreview = (0,router.useRouter)().isPreview;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var cities = (0,react.useMemo)(function() {
        var ref;
        var cities = [];
        if (multi && ((ref = multi["@nodes"]) === null || ref === void 0 ? void 0 : ref.length)) {
            cities = multi["@nodes"].flatMap(function(node) {
                var ref, ref1;
                var city = multi[node].city;
                // Unpublished city items stay unresolved (plain UUID) in the delivery API
                if (!city || typeof city !== "object" || !city.address) return [];
                var imageData = imageDataHandler(city.cityImage, {
                    maxViewport: app/* Viewport.sm */.l_.sm
                });
                var _externalLinkText, _secondExternalLinkText;
                return {
                    name: city.name,
                    cityLeadText: city.cityLeadText,
                    address: city.address,
                    alt: city.alt,
                    imageData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
                        imageSrc: imageData.src,
                        credits: (ref = city.cityImage) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.rights
                    }),
                    externalLink: city.externalLink ? (0,magnolia/* formatPageLink */.Jd)(city.externalLink, isPreview) : null,
                    externalLinkText: (_externalLinkText = city.externalLinkText) !== null && _externalLinkText !== void 0 ? _externalLinkText : null,
                    secondExternalLink: city.secondExternalLink ? (0,magnolia/* formatPageLink */.Jd)(city.secondExternalLink, isPreview) : null,
                    secondExternalLinkText: (_secondExternalLinkText = city.secondExternalLinkText) !== null && _secondExternalLinkText !== void 0 ? _secondExternalLinkText : null
                };
            });
        }
        return cities;
    }, [
        imageDataHandler,
        multi,
        isPreview
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_66bc4f34.b, {
        cities: cities,
        MAPBOX_TILE_LAYER: MAPBOX_TILE_LAYER,
        MAPBOX_TOKEN: MAPBOX_TOKEN
    });
}
/* harmony default export */ var MapBox_MapBox = ((/* unused pure expression or super */ null && (MapBox)));

;// CONCATENATED MODULE: ./src/magnolia/components/MapBox/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 8572:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ue; },
/* harmony export */   "a": function() { return /* binding */ u; },
/* harmony export */   "b": function() { return /* binding */ We; },
/* harmony export */   "s": function() { return /* binding */ r; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3355);
/* harmony import */ var _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5905);
/* harmony import */ var _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(965);
/* harmony import */ var _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7977);
/* harmony import */ var _index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8517);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4877);








const $ = "MapBox__container", G = "MapBox__card", K = "MapBox__large-desktop", V = "MapBox__desktop", j = "desktop", q = "MapBox__image", J = "MapBox__tablet", Q = "MapBox__dropDown", Y = "MapBox__small__tablet", Z = "MapBox__mobile", ee = "MapBox__content", te = "MapBox__contentOnMap", ae = "MapBox__contentOnMap__hidden", oe = "picture", ne = "MapBox__svg__close", se = "MapBox__leadText", re = "MapBox__buttons", r = {
  mapBoxContainer: $,
  mapBoxCard: G,
  mapBoxLargeDesktop: K,
  mapBoxDesktop: V,
  desktop: j,
  mapBoxImage: q,
  mapBoxTablet: J,
  mapBoxDropDown: Q,
  mapBoxSmallTablet: Y,
  mapBoxMobile: Z,
  mapBoxContent: ee,
  mapBoxContentOnMap: te,
  mapBoxContentOnMapHidden: ae,
  picture: oe,
  mapBoxSvgClose: ne,
  mapBoxLeadText: se,
  mapBoxButtons: re
}, pe = "MapDropdown", ce = "MapDropdown__list", le = "MapDropdown__list__item", me = "MapDropdown__selected", ie = "MapDropdown__chevron", g = {
  mapDropdown: pe,
  mapDropdownList: ce,
  mapDropdownListItem: le,
  mapDropdownSelected: me,
  mapDropdownChevron: ie
};
var u = /* @__PURE__ */ ((t) => (t.MapOnImage = "mapOnImage", t.MapOnMap = "mapOnMap", t))(u || {});
function de({
  cities: t,
  variant: o,
  onClickShowMarker: s,
  selected: l,
  setSliderIndex: x
}) {
  const [a, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [m, M] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("Select a city "), [c, k] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), I = () => {
    n(!a), k(!c), M("Select a city");
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      "data-testid": "mapbox-dropdown",
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(g.mapDropdown),
      onClick: () => I()
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        "data-testid": "mapbox-dropdown-selected",
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          g.mapDropdownSelected,
          c ? _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyText : _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyTextBold
        ),
        id: "selected"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, c ? m : l?.name),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
        {
          icon: c ? _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_UP : _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_DOWN,
          size: 18,
          color: "#002EA2",
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(g.mapDropdownChevron)
        }
      )
    ),
    a ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "ul",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(g.mapDropdownList),
        "data-testid": "mapbox-dropdown-list"
      },
      t?.map((N, _) => {
        const w = N.city.name;
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "li",
          {
            "data-testid": "mapbox-dropdown-item",
            className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
              g.mapDropdownListItem,
              _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyText
            ),
            onClick: () => {
              o === u.MapOnMap ? (n(!a), s && setTimeout(() => {
                s(t[_].position, _);
              }, 200)) : (x?.(_), n(!a), M(w), k(!c));
            },
            key: w
          },
          w
        );
      })
    ) : null
  );
}
const D = {
  toggle: { type: "toggle" }
}, S = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(void 0), L = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(void 0);
function xe(t, o) {
  switch (o.type) {
    case D.toggle.type:
      return { ...t, isRealMapShown: !t.isRealMapShown };
    default:
      throw new Error(`Unhandled action type: ${o}`);
  }
}
function ge({ children: t }) {
  const [o, s] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(xe, {
    isRealMapShown: !1
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(L.Provider, { value: s }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(S.Provider, { value: o }, t));
}
function Be() {
  const t = react__WEBPACK_IMPORTED_MODULE_0__.useContext(S);
  if (t === void 0)
    throw new Error("useMap must be used within a MapProvider");
  return t;
}
function y() {
  const t = react__WEBPACK_IMPORTED_MODULE_0__.useContext(L);
  if (t === void 0)
    throw new Error("useMap must be used within a MapProvider");
  return t;
}
const ue = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  function(o, s) {
    const l = y(), {
      cities: x,
      selected: a,
      variant: n,
      togglePopUp: m,
      onClickShowMarker: M,
      setSliderIndex: c
    } = o;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          n === u.MapOnImage ? r.mapBoxContent : r.mapBoxContentOnMap
        ),
        "data-testid": "mapbox-content",
        ref: s
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          "data-testid": "mapbox-close",
          onClick: () => {
            n === u.MapOnImage ? l(D.toggle) : m?.();
          },
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(r.mapBoxSvgClose)
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { size: 14, icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CLOSE, color: "#002EA2" })
      ),
      a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
        {
          credits: a.imageData.credits ?? "",
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(r.mapBoxImage),
          src: a.imageData.imageSrc,
          width: a.imageData.width,
          height: a.imageData.height,
          altText: a.alt,
          imageLoader: a.imageData.imageLoader,
          styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.a.PROMOTION,
          "data-testid": "mapbox-pop-up-image"
        }
      ),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        de,
        {
          variant: n,
          cities: x,
          selected: a,
          onClickShowMarker: M,
          setSliderIndex: c
        }
      ),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(r.mapBoxLeadText, _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyText) }, a?.cityLeadText),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(r.mapBoxButtons) }, a?.externalLink && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_4__.L,
        {
          href: a?.externalLink,
          locale: a?.externalLinkLocale,
          target: "_blank"
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.Primary,
          {
            asDiv: !0,
            "data-testid": "mapbox-explore-services-button",
            text: a?.externalLinkText ?? "",
            icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.ARROW_UP_RIGHT
          }
        )
      ), a?.secondExternalLink && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_4__.L,
        {
          href: a?.secondExternalLink,
          locale: a?.secondExternalLinkLocale,
          target: "_blank"
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.Secondary,
          {
            asDiv: !0,
            "data-testid": "mapbox-more-information-button",
            text: a?.secondExternalLinkText ?? "",
            icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_2__.W.ARROW_UP_RIGHT
          }
        )
      ))
    );
  }
);
function Me({ cities: t }) {
  const o = y(), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_6__.u)(s, (n) => {
    n && o(D.toggle);
  });
  const l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => t.map((n) => ({ position: [0, 0], city: n })),
    [t]
  ), [x, a] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const n = setInterval(() => {
      a((m) => m === t.length - 1 ? 0 : m + 1);
    }, 12e3);
    return () => clearInterval(n);
  }, [t.length]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    ue,
    {
      variant: u.MapOnImage,
      selected: l[x].city,
      setSliderIndex: a,
      cities: l,
      ref: s
    }
  );
}
const Ee = "/static/images/mapbox/Tablet.webp", be = ({ className: t }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: t }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
  {
    src: Ee,
    width: 2046,
    height: 2732,
    altText: "Background image",
    styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.a.MAPBOX
  }
)), he = "/static/images/mapbox/Smalltablet.webp", _e = ({ className: t }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: t }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
  {
    width: 1798,
    height: 2401,
    src: he,
    altText: "Background image",
    styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.a.MAPBOX
  }
)), we = "/static/images/mapbox/Desktop.webp", De = ({ className: t }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: t }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
  {
    src: we,
    width: 2878,
    height: 2048,
    altText: "Background image",
    styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.a.MAPBOX
  }
)), ke = "/static/images/mapbox/Mobile.webp", fe = ({ className: t }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: t }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
  {
    src: ke,
    width: 1198,
    height: 1600,
    altText: "Background image",
    styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.a.MAPBOX
  }
)), ve = "/static/images/mapbox/Largedesktop.webp", Ce = ({ className: t }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: t }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
  {
    src: ve,
    width: 3840,
    height: 2731,
    altText: "Background image",
    styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.a.MAPBOX
  }
));
function Oe() {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Ce,
    {
      className: r.mapBoxLargeDesktop,
      "data-testid": "mapbox-large-desktop"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    De,
    {
      className: r.mapBoxDesktop,
      "data-testid": "mapbox-desktop"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(be, { className: r.mapBoxTablet, "data-testid": "mapbox-tablet" }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _e,
    {
      className: r.mapBoxSmallTablet,
      "data-testid": "mapbox-small-tablet"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(fe, { className: r.mapBoxMobile, "data-testid": "mapbox-mobile" }));
}
const Te = (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => Promise.all(/* import() */[__webpack_require__.e(9934), __webpack_require__.e(5179), __webpack_require__.e(9492)]).then(__webpack_require__.bind(__webpack_require__, 9492)));
function We(t) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ge, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Se, { ...t }));
}
function Se(t) {
  const { isRealMapShown: o } = Be(), s = !!(o && t.MAPBOX_TOKEN);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B,
    {
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B.Padding.NONE,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B.Padding.NONE,
      "data-testid": "mapbox-block"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B.Content,
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(r.mapBoxCard),
        "data-testid": "mapbox-content",
        limitedWidth: !s
      },
      s ? (
        // Real Mapbox
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Le, { fallback: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(C, { cities: t.cities }) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Suspense, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Te, { ...t })))
      ) : (
        // Static slider of cities
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(C, { cities: t.cities })
      )
    )
  );
}
function C({ cities: t }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Oe, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Me, { cities: t }));
}
class Le extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(o) {
    super(o), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}

//# sourceMappingURL=index-66bc4f34.mjs.map


/***/ })

}]);